import React from 'react';
import { BaseText } from './BaseText';
import { defineFontSettings } from './fontSettings';

import styled from 'styled-components';

const Wrapper = styled.h1`
  font-size: inherit;
  line-height: inherit;
`;

export const H1 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings(
    { fontSize: '36px', lineHeight: '40px', textCase: 'uppercase' },
    { fontSize: '64px', lineHeight: '76px', textCase: 'uppercase' }
  );
  return (
    <BaseText fontSettings={fontSettings} {...props}>
      <Wrapper>{children}</Wrapper>
    </BaseText>
  );
};
